module.exports = __webpack_public_path__ + "static/media/frame_03.fca63294.png";